import { OnlyNumber } from '../Directives/onlynumber';
import { NumberwithNegativeSign } from '../Directives/Numberwithnegativesign';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MaterialModule } from './material.module';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NumberWithDecimal } from '../Directives/numberwithdecimal';
import { EnergymeterreportComponent } from '../reportgrid/energymeterreport/energymeterreport.component';
import { FlowmeterreportComponent } from '../reportgrid/flowmeterreport/flowmeterreport.component';
import { AdminaddsiteComponent } from '../reportgrid/adminaddsite/adminaddsite.component';
import { CardChildDataComponent } from '../reportgrid/card-child-data/card-child-data.component';
import 'hammerjs';
import 'web-animations-js';
import { LoaderComponent } from './Loader/loader.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { TimeZone } from '../Directives/TimeZone';
import { MatRadioModule } from "@angular/material/radio";
import { HighchartsChartModule } from 'highcharts-angular';
import { MatIconModule } from '@angular/material/icon';


export const MY_CUSTOM_FORMATS = {};

@NgModule({
    imports: [
        MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, NgxDocViewerModule, MatRadioModule, HighchartsChartModule, MatIconModule
    ],
    exports: [OnlyNumber, MaterialModule, AutoCompleteComponent, ReactiveFormsModule, FormsModule, CommonModule, MatRadioModule,
        NumberWithDecimal, EnergymeterreportComponent, FlowmeterreportComponent, NumberwithNegativeSign,
        LoaderComponent, AdminaddsiteComponent, CardChildDataComponent, NgxDocViewerModule, TimeZone, HighchartsChartModule,MatIconModule
    ],
    declarations: [OnlyNumber, AutoCompleteComponent, NumberWithDecimal, EnergymeterreportComponent, FlowmeterreportComponent,
        NumberwithNegativeSign, AdminaddsiteComponent, CardChildDataComponent, LoaderComponent, TimeZone
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class SharedModule { }
